import React from 'react';
import { styled } from '@linaria/react';

const GridContainer = styled.div`
  display: flex;
  flex-direction: ${(props) => props.direction};
  margin-bottom: 40px;
  flex-wrap: ${(props) => (props.flexWrap ? 'wrap' : 'no-wrap')};
`;

const GridItemContainer = styled.div`
  width: ${(props) => props.width}px;
  margin-right: ${(props) => (props.margin ? 36 : 0)}px;
  box-sizing: border-box;
`;

export const Grid = ({ children, direction = 'row', wrap = false, style: overwriteStyle, ...attr }) => {
  return (
    <GridContainer direction={direction} flexWrap={wrap} style={overwriteStyle} {...attr}>
      {children}
    </GridContainer>
  );
};

export const GridItem = ({ size = 1, margin = true, children, style: overwriteStyle, ...attr }) => {
  const width = 116 * size - (size === 1 ? 36 : 0);

  return (
    <GridItemContainer width={width} margin={margin} style={overwriteStyle} {...attr}>
      {children}
    </GridItemContainer>
  );
};
